export default __webpack_public_path__ + "static/media/products_313.0b1c797d.jpg";